import { RouteConfig } from '../types';
import { ONBOARDING_KEYS } from '../constants';
import { HELP_CENTER_LINKS } from '../helpCenterLinks';

export const customersPageSteps = [
  {
    element: '[data-onboarding="customers-page"]',
    popover: {
      title: 'Customers Dashboard',
      description:
        `View all <a href="${HELP_CENTER_LINKS.customers}" target="_blank" class="text-lime underline">customers</a> in your organisation. Search, add new customers, and filter by status.`,
      side: 'bottom' as const,
      align: 'start' as const,
    },
  },
  {
    element: '[data-onboarding="customers-add-button"]',
    popover: {
      title: 'Add Customer',
      description: 'Create a new customer. Enter their name, contact details, and address.',
      side: 'bottom' as const,
      align: 'end' as const,
    },
  },
  {
    element: '[data-onboarding="customers-column-toggle"]',
    popover: {
      title: 'Search and Filter Tools',
      description:
        'Use the search bar to find customers by name. Customize your view with column visibility and open the filters panel to filter by active or archived status.',
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="customers-page"] ~ * table tbody, [data-onboarding="customers-page"] + * table tbody',
    popover: {
      title: 'Customers Table',
      description:
        `All customers that match your search and filters are listed here. Click a customer name to view their details, sites, and <a href="${HELP_CENTER_LINKS.devices}" target="_blank" class="text-lime underline">devices</a>.`,
      side: 'top' as const,
      align: 'start' as const,
    },
  },
];

export const customerDetailSteps = [
  {
    element: '[data-onboarding="customer-detail-contact-info"]',
    popover: {
      title: 'Customer Information',
      description:
        "View the customer's account number, email, phone, and address. The map shows the customer's location.",
      side: 'bottom' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="customer-detail-edit-button"]',
    popover: {
      title: 'Edit Customer',
      description:
        'Click this button to update the customer\'s details, including their name, contact information, and address.',
      side: 'top' as const,
      align: 'center' as const,
    },
  },
  {
    element: '[data-onboarding="customer-detail-content"]',
    popover: {
      title: 'Sites',
      description:
        'View and manage the customer\'s sites. Use search to filter sites by name or location, toggle between grid and table views, or add new sites.',
      side: 'top' as const,
      align: 'center' as const,
    },
  },
];

export const customerRoutes: RouteConfig[] = [
  {
    id: 'customers',
    processName: ONBOARDING_KEYS.customers,
    match: (path: string) => path === '/customers',
    steps: customersPageSteps,
  },
  {
    id: 'customer-detail',
    processName: ONBOARDING_KEYS.customerDetail,
    match: (path: string) => /^\/customers\/[^/?]+/.test(path),
    steps: customerDetailSteps,
  },
];
